module.exports = __webpack_public_path__ + "img/kzfw-banner.0e04d371.png";